function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "20",
  cy: "20",
  r: "18",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M18.46 21.82a16 16 0 005 3.68l1.66-1.66a3.62 3.62 0 01.65-.51 1.19 1.19 0 011.23-.07L30.52 25a2.63 2.63 0 01-.55 3.5 6.83 6.83 0 01-4.25 1.87s-4.26-.71-9.66-6.11-6.06-9.7-6.06-9.7a6.81 6.81 0 011.88-4.25 2.62 2.62 0 013.49-.55L17 13.34a1.19 1.19 0 010 1.14 4.6 4.6 0 01-.51.64l-1.67 1.66a16 16 0 003.64 5.04z"
}));